"use strict";
/*
 * Created on Thu Jun 28 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Competing company/organization.
 *
 * @author Jaroslav Sevcik
 */


var Competitor =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(Competitor, _DomainObject_1$Domai);

  function Competitor(id, externalId, name) {
    var _this;

    _classCallCheck(this, Competitor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Competitor).call(this));
    _this.id = id;
    _this.externalId = externalId;
    _this.name = name;
    return _this;
  }

  return Competitor;
}(DomainObject_1.DomainObject);

exports.Competitor = Competitor;
Competitor.COMPANIES_LOOKUP = CodebookLookupSequence_1.CodebookLookupSequence.Competitor;

Competitor.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(Competitor.name);
  return {
    id: builder.str('id'),
    externalId: builder.str('externalId'),
    name: builder.str('name')
  };
}();